var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53263 17.4522C6.53263 17.9123 6.90178 18.2857 7.35662 18.2857C7.81147 18.2857 8.18061 17.9123 8.18061 17.4522V5.8523L10.8053 8.51724C11.1261 8.84397 11.6469 8.84397 11.9699 8.51946C12.2929 8.19496 12.294 7.66708 11.9721 7.34036L7.94001 3.24515C7.7049 3.00511 7.34893 2.93509 7.04241 3.0629C6.73369 3.19181 6.53263 3.4952 6.53263 3.83304V17.4522ZM3.32413 8.7624C3.11429 8.7624 2.90334 8.68127 2.74294 8.51902C2.41994 8.19451 2.41884 7.66775 2.74074 7.34102L4.34478 5.71072C4.66668 5.38399 5.18744 5.38399 5.51045 5.7085C5.83235 6.033 5.83345 6.56088 5.51264 6.88761L3.90751 8.5168C3.74711 8.68127 3.53507 8.7624 3.32413 8.7624ZM16.859 20.9367C16.9601 20.9789 17.0666 21 17.1732 21C17.3885 21 17.5995 20.9155 17.7566 20.7544L21.2074 17.2482C21.5283 16.9215 21.5272 16.3936 21.2053 16.0691C20.8822 15.7446 20.3604 15.7457 20.0396 16.0713L17.9972 18.1484V6.54621C17.9972 6.08612 17.6291 5.71272 17.1732 5.71272C16.7184 5.71272 16.3492 6.08612 16.3492 6.54621V20.1665C16.3492 20.5044 16.5503 20.8077 16.859 20.9367ZM14.1607 18.2875C14.3222 18.452 14.5342 18.5331 14.7452 18.5331C14.955 18.5331 15.166 18.452 15.3264 18.2897C15.6494 17.9652 15.6505 17.4385 15.3297 17.1117L13.7256 15.4814C13.4026 15.1547 12.8819 15.1547 12.56 15.4792C12.2369 15.8037 12.2358 16.3316 12.5567 16.6583L14.1607 18.2875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/Swap.4bb1acc600fe40930970e823b1de78f9.svg";
export { ForwardRef as ReactComponent };